import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { errorsInterceptor } from './@core/interceptors/errors.interceptor';
import { tokenInterceptor } from './@core/interceptors/token.interceptor';
import { routes } from './app.routes';
import { skyLara } from './app.theme';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    ConfirmationService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptors([tokenInterceptor, errorsInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: skyLara,
        options: {
          darkModeSelector: false,
        },
      },
    }),
  ],
};
